import { SWF_STAGE_HEIGHT, SWF_STAGE_WIDTH } from "../core/swfBattleStage";

export const DEFAULT_STAGE_VERTICAL_OFFSET_PERCENT = 10;

/** 正值向下移动内容；百分比以完整的原始舞台高度为基准。 */
export function stageCameraCenterForOffsetPercent(
    verticalOffsetPercent = DEFAULT_STAGE_VERTICAL_OFFSET_PERCENT,
) {
    return {
        x: SWF_STAGE_WIDTH / 2,
        y: SWF_STAGE_HEIGHT / 2 - SWF_STAGE_HEIGHT * verticalOffsetPercent / 100,
    };
}
